import React, { useState } from "react";
import styled, { withTheme } from "styled-components";
import FlexContainer from "../../Container/FlexContainer";
import { ButtonTxt, CaptionTxt } from "../../Typography";
import LinkArrow from "./LinkArrow";
import SmallLink from "./SmallLink";

import theme from "../../../styles/theme";

const StyledBlockLink = styled.a`
  display: flex;
  padding-bottom: 24px;
  position: relative;
  cursor: pointer;
  text-decoration: none;
  &:hover {
    .text {
      color: ${() => theme.colors.green3};
    }
  }
`;

const TextWrapper = styled.div`
  width: 300px;
  padding-right: 40px;
`;

const StyledHeading = styled(ButtonTxt)`
  color: ${() => theme.colors.green5};
  transition: color 250ms ease-in-out 0s;
  margin-top: 0;
  margin-bottom: 4px;
`;

const StyledSubheading = styled(CaptionTxt)`
  color: ${() => theme.colors.green5};
  transition: color 250ms ease-in-out 0s;
  font-size: 0.75em;
  margin: 0;
`;

const Icon = styled.img`
  width: 20px;
  height: 20px;
  margin-right: 8px;
`;

const ArrowWrapper = styled.div`
  position: absolute;
  width: 14px;
  height: 14px;
  top: 0px;
  right: 0px;
`;

const SubLinkWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 28px;
  margin-bottom: 30px;
`;

const StyledSubLink = styled(SmallLink)`
  color: ${() => theme.colors.green4};
  margin-bottom: 14px;
  &:last-child {
    margin-bottom: 32px;
  }
`;

const NavBlock = ({ navBlock }) => {
  const [active, setActive] = useState(false);
  return (
    <div
      onMouseEnter={() => setActive(true)}
      onMouseLeave={() => setActive(false)}
    >
      <StyledBlockLink href={navBlock.primaryLink[0].url}>
        <FlexContainer>
          <Icon src={navBlock.icon.asset} />
          <TextWrapper>
            <StyledHeading className="text">{navBlock.heading}</StyledHeading>
            <StyledSubheading className="text">
              {navBlock.subheading}
            </StyledSubheading>
            <ArrowWrapper>
              <LinkArrow
                right
                fillColor={active ? theme.colors.green3 : theme.colors.green5}
              />
            </ArrowWrapper>
          </TextWrapper>
        </FlexContainer>
      </StyledBlockLink>
      <SubLinkWrapper>
        {navBlock.subLinks?.map((link, i) => (
          <StyledSubLink key={`navblock_${i}`} href={link.url}>{link.label}</StyledSubLink>
        ))}
      </SubLinkWrapper>
    </div>
  );
};

export default withTheme(NavBlock);
